import { useStyles } from "./LeaderboardUsers.style";
import { LoadMoreObserver } from "@onmo/ui";
import { Leaderboard, LeaderboardUser } from "@onmo/graphql/graphql";
import { meGQL } from "../../../graphql";
import { useQuery } from "@apollo/client";
import RankCard from "../../core/RankCard/RankCard";
import RankCardLoading from "../../core/RankCard/RankCardLoading";
import { useMemo } from "react";
import { LeaderboardType } from "../../../constants/user";
import { useRankInfo } from "../../../hooks/useRankInfo";
import { isNull } from "lodash-es";

type ILeaderboardUsersProps = {
  leaderboards: Leaderboard;
  loadMoreUser: () => void;
  type?: LeaderboardType;
  loading: boolean;
};

const LeaderboardUsers: React.FC<ILeaderboardUsersProps> = (props) => {
  const classes = useStyles();
  const { leaderboards, loadMoreUser, type, loading } = props;
  const { data: dataMe } = useQuery(meGQL);
  const myRank = useMemo(() => {
    if (!leaderboards) return null;
    return {
      rank: leaderboards.rank,
      score: leaderboards.score,
    };
  }, [dataMe?.me.id, leaderboards]);

  const { newRankWithState } = useRankInfo({
    rank: myRank?.rank,
    type: type,
  });

  return (
    <div className={classes.rankList}>
      {!isNull(myRank?.rank) && (
        <>
          <RankCard
            rank={myRank?.rank + 1}
            username={"Me"}
            reward={myRank?.score}
            avatar={dataMe?.me.avatar}
            myRank
            rankState={newRankWithState?.rankState}
          />
          <span className={classes.divider} />
        </>
      )}
      {loading || !leaderboards
        ? Array.from(new Array(20)).map((_, idx) => (
            <RankCardLoading key={idx} />
          ))
        : leaderboards.items.length === 0
        ? Array.from(new Array(3)).map((_, idx) => (
            <RankCard rank={idx + 1} username="waiting..." />
          ))
        : leaderboards?.items.map((item: LeaderboardUser, idx: number) => {
            if (!item.user || item.user?.id === dataMe?.me.id) return null;
            return (
              <RankCard
                key={idx}
                rank={item.rank + 1}
                username={item.user.username}
                reward={item.score}
                avatar={item.user.avatar}
              />
            );
          })}
      <LoadMoreObserver loadMore={loadMoreUser} />
    </div>
  );
};

export default LeaderboardUsers;
